module.exports = __webpack_public_path__ + "static/media/apu.b63bc0d4.jpeg";